import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { WITHDRAWALS_ROUTE_PATHS } from './config';

export const WITHDRAWALS_ROUTES: TApplicationRoute[] = [
  {
    id: 'movements-withdrawals',
    path: WITHDRAWALS_ROUTE_PATHS.withdrawals,
    component: lazy(() => import('./pages/withdrawals-page')),
    layout: 'default',
    permissions: { scopes: ['movements-withdrawals'] },
    menu: {
      title: 'pages.movements.withdrawals.title',
    },
  },
];
